module.exports = __webpack_public_path__ + "img/trophy-other.68c0dedb.png";